import NeuralNetworksImg from '../assets/neural-networks.jpg';

const notes = [
    // Generative Adversarial Networks Specialization
    {
      id: 'build-basic-gans-C1W1',
      title: 'Week 1 - Build Basic Generative Adversarial Networks (GANs)',
      description: 'In this week, I learned about the basic components of GANs and built the basic Generative Adversarial Networks (GANs) using PyTorch.',
      image: NeuralNetworksImg,
    },
    
      
];
  
const notes_categories = [
{
    name: 'Generative Adversarial Networks Specialization | DeepLearning.AI | Coursera',
    notes: [
    notes[0],
    ],
},
];


export { notes, notes_categories };